import styled from 'styled-components';

const TagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
  width: 100%;
  min-width: 200px;
  border-radius: 20px;

  ${props => props.scrollable && `
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;
 
const Tag = styled.div`
  display: inline-flex;
  padding: 4px 12px;
  align-items: center;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.colors.clearGray};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.darkGray};
  background: ${({ theme }) => theme.colors.white};
`; 

export { TagContainer, Tag }; 